// import { getPreviousMonths } from '../lib/getPreviousMonths';

// export const TIME_FRAMES_VALUES: Record<ChartTimeframe, QueryFilter> = {
//     '3m': getPreviousMonths(3),
//     '6m': getPreviousMonths(6),
//     y: getPreviousMonths(13),
//     all: { startDate: '2021-01', endDate: '2024-12' },
// };

export const CORRECT_DATA_REGEX = /^\d{2}\.\d{4}$/;
